/**
 * Class describing the values and functions of a Position
 * Positions are used to describe the location of a point in space
 * 
 * @export {Position}
 * @class Position
 */

export default class Position {
    constructor (x, y, z) {
        this._x = x;
        this._y = y;
        this._z = z;
    }

    get X() {
        return this._x;
    }

    get Y() {
        return this._y;
    }

    get Z() {
        return this._z;
    }

    /**
     * Determines the distance between two Positions in space and returns that distance
     * 
     * @static
     * @param {Position} pos1 
     * @param {Position} pos2 
     * @returns {number}
     * @memberof Position
     */
    static getDistance (pos1, pos2) {
        const xDist = Math.pow(pos1.X - pos2.X, 2);
        const yDist = Math.pow(pos1.Y - pos2.Y, 2);
        const zDist = Math.pow(pos1.Z - pos2.Z, 2);
        return Math.sqrt(xDist + yDist + zDist);
    }
}



// WEBPACK FOOTER //
// ./src/classes/Position.js